import React from "react";
import { StyleSheet, View, useWindowDimensions } from "react-native";
import Logo from "../../assets/Logo";
import LogoMark from "../../assets/LogoMark";
import AppHeaderMenuButton from "./AppHeaderMenuButton";
import useHeaderTopPadding from "./useHeaderTopPadding";

type Props = {
  onPressMenu: () => void;
  backgroundColor?: string;
  logoTextColor?: string;
  rightComponent?: React.ReactNode;
};

const MOBILE_BREAKPOINT = 768;

export default function AppHeaderView({
  onPressMenu,
  backgroundColor,
  logoTextColor,
  rightComponent,
}: Props) {
  const resolvedBackgroundColor = backgroundColor ?? "#F6F7F9";
  const { width } = useWindowDimensions();
  const isMobile = width < MOBILE_BREAKPOINT;
  const headerTopPadding = useHeaderTopPadding();

  return (
    <View
      style={[
        styles.safeArea,
        {
          backgroundColor: resolvedBackgroundColor,
          paddingTop: headerTopPadding,
        },
      ]}
    >
      <View
        style={[styles.container, { backgroundColor: resolvedBackgroundColor }]}
      >
        <View style={styles.left}>
          {isMobile ? (
            <LogoMark width={40} height={40} />
          ) : (
            <>
              <Logo textColor={logoTextColor} />
              <View style={styles.kexoTextBox} />
            </>
          )}
        </View>

        {rightComponent ?? <AppHeaderMenuButton onPress={onPressMenu} />}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    backgroundColor: "#F6F7F9",
  },
  container: {
    backgroundColor: "#F6F7F9",
    paddingHorizontal: 24,
    paddingVertical: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  left: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },

  /**
   * ТЗ для текста KNEXO:
   * width: 145.3452
   * height: 32.9947
   * top: 2.86px; left: 46.66px
   *
   * В RN "top/left" обычно не задают для inline, поэтому делаем размер/отступ.
   * Если текст уже внутри Logo.tsx — этот блок не нужен.
   */
  kexoTextBox: {
    width: 145.34519958496094,
    height: 32.99472427368164,
    opacity: 1,
    // можно оставить как "плейсхолдер", если Logo.tsx уже рисует KNEXO
  },
});
